import {VIEWS} from "lib/commons/views";
import {IDepotResEnv, IDepotResUiEnv, IDepotShortResUiEnv, JStoreChangeProps} from "lib/store/depot";
import {IReg, REG} from "lib/commons/registry";
import {DOMSH} from "lib/commons/xml/domsh";
import {DOM, JSX} from "lib/commons/xml/dom";
import {OResBodyViewInit, ResBodyView} from "back/store/views/resViewer";
import {JNodeInfos, JNodeShortProps, URLTREE, UrlTreeSrv} from "lib/store/urlTree";
import {OResGridInit, ResGrid} from "back/store/widgets/resGrid";
import {GridColDef} from "back/commons/widgets/grid-core";
import {CellBuilderResTile} from "back/store/widgets/resGridColumns";
import {MsgLabel} from "back/commons/basis";
import {RES} from "lib/store/res";
import {FocusLiveRes} from "back/store/actions/depotActions";
import {Button} from "back/commons/widgets/buttons";
import {ResChildrenArea, ResTreeArea} from "back/store/areas/resViewAreas";

/** Init commun à tous les widget affichante un view d'une res. */
export interface OResContentViewInit extends OResBodyViewInit {

	subPath?: string

	treeSrv?: UrlTreeSrv;
}

/**
 * Content iframe
 */
export interface ResFrameView extends ResBodyView {
	initialize(init: OResFrameViewInit): this
}

export interface OResFrameViewInit extends OResContentViewInit {
}

export class ResFrameView extends ResBodyView {

	config: OResContentViewInit;

	treeSrv: UrlTreeSrv;

	subPath: string;

	protected _initialize(init: OResFrameViewInit) {
		this.reg = init.reg || init.areaContext?.reg;
		this.config = init;
		super._initialize(init); //init this.area, this.areaContext
		this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		this.subPath = init.subPath;
		this.treeSrv = init.treeSrv || this.reg.env.universe.urlTree;
	}

	protected draw() {
		this.initBarActions(this.config, this.shadowRoot);
		this.shadowRoot.append(<iframe src={this.treeSrv.urlFromPath(URLTREE.appendToPath(this.reg.env.nodeInfos.permaPath, this.subPath), 'evenIfTrashed')} allowfullscreen/>);
	}

}

REG.reg.registerSkin('store-res-frame', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	iframe {
		flex: 1;
		background-color: #fff;
		border: none;
		border: 1px solid var(--border-color);
		margin-bottom: .5em;
	}
`);

customElements.define('store-res-frame', ResFrameView);

/**
 * Content img
 */
export interface ResImgView extends ResFrameView {
	initialize(init: OResImgViewInit): this
}

export interface OResImgViewInit extends OResContentViewInit {
	checkboard?: boolean
}

export class ResImgView extends ResFrameView {

	protected _initialize(init: any) {
		super._initialize(init);
		if (init.checkboard) DOM.addClass(this, "checkboard");
	}

	protected draw() {
		this.initBarActions(this.config, this.shadowRoot);
		this.shadowRoot.append(<img src={this.treeSrv.urlFromPath(URLTREE.appendToPath(this.reg.env.nodeInfos.permaPath, this.subPath), 'evenIfTrashed')} allowfullscreen/>);
	}
}

REG.reg.registerSkin('store-res-img', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		justify-content: center;
		padding: 1px;
	}

	#bodyActions {
		border-bottom: 1px solid var(--border-color);
	}

	img {
		width: 100%;
		height: 100%;
		max-width: max-content;
		max-height: max-content;
		object-fit: contain;
		align-self: center;
		/*background: white;*/
	}

	:host(.checkboard) > img {
		background: /*white*/ repeating-conic-gradient(#88888850 0% 25%, transparent 0% 50%) 50%/10px 10px;
	}
`);

customElements.define('store-res-img', ResImgView);

/**
 * Content audio
 */
export interface ResAudioView extends ResFrameView {
	initialize(init: OResAudioViewInit): this
}

export interface OResAudioViewInit extends OResContentViewInit {

}

export class ResAudioView extends ResFrameView {

	protected draw() {
		this.initBarActions(this.config, this.shadowRoot);
		this.shadowRoot.append(<audio src={this.treeSrv.urlFromPath(URLTREE.appendToPath(this.reg.env.nodeInfos.permaPath, this.subPath), 'evenIfTrashed')} controls/>);
	}
}

REG.reg.registerSkin('store-res-audio', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1px;
		margin-top: 1em;
	}

	#bodyActions {
		border-bottom: 1px solid var(--border-color);
	}

`);

customElements.define('store-res-audio', ResAudioView);


/**
 * Content video
 */
export interface ResVideoView extends ResFrameView {
	initialize(init: OResVideoViewInit): this
}

export interface OResVideoViewInit extends OResContentViewInit {

}

export class ResVideoView extends ResFrameView {

	protected draw() {
		this.initBarActions(this.config, this.shadowRoot);
		this.shadowRoot.append(<video src={this.treeSrv.urlFromPath(URLTREE.appendToPath(this.reg.env.nodeInfos.permaPath, this.subPath), 'evenIfTrashed')} controls/>);
	}
}

REG.reg.registerSkin('store-res-video', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		justify-content: center;
		padding: 1px;
		margin-top: 1em;
	}

	#bodyActions {
		border-bottom: 1px solid var(--border-color);
	}

	video {
		flex: 1;
		align-self: center;
		overflow: hidden;
		max-width: 100%;
	}

`);

customElements.define('store-res-video', ResVideoView);


/**
 * Affichage des fils en tuiles.
 */
export interface ResChildrenView extends ResBodyView {
	initialize(init: OResChildrenViewInit): this
}

export interface OResChildrenViewInit extends OResContentViewInit {
	grid?: OResGridInit
	max?: number
	/**
	 * Filre pour lister les fils et la recherche.
	 * Exemples :
	 * - "isFolder"
	 * - "isFolder & !inTrash & !unlisted &!moved"
	 * - "usable" ( = !inTrash & !unlisted &!moved)
	 * - "regexpPrc(img.*) & !inTrash"
	 * - "prc(image,audio,video) & !inTrash"
	 * - null : pas de filtre
	 *
	 * Note : filtre toujours ajouté à celui-ci (même si null) : isResRoot&!isQuery
	 *
	 * @see eu.scenari.urltree.util.UrlTreeNodePredicates
	 */
	filter?: string
}

export class ResChildrenView extends ResBodyView {

	config: OResChildrenViewInit;

	reg: IReg<IDepotResUiEnv | IDepotShortResUiEnv>;

	nodeFilter?: string

	protected _initialize(init: OResChildrenViewInit) {
		this.reg = init.reg || init.areaContext?.reg;
		super._initialize(init); //init this.area, this.areaContext
		this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		if (!init.max) init.max = 1000;
		this.config = init;
		this.nodeFilter = init.filter ? `${encodeURIComponent(init.filter)}%26isResRoot%26!isQuery` : `isResRoot%26!isQuery`;
	}

	protected draw() {
		const urlTreeSrv = this.reg.env.universe.adminUrlTree;
		const initGrid: OResGridInit = {
			reg: this.reg,
			skinOver: 'store-res-tile',
			infoBroker: this.reg.env.infoBroker,
			columnDefs: [new GridColDef("tile").setFlex("auto", 1, 1).setCellBuilder(new CellBuilderResTile(this.reg))],
			selType: "monoClick",
			skinScroll: "scroll/large",
			hideHeaders: true,
			emptyBody: () => new MsgLabel().initialize({reg: this.reg, level: "info", label: "Dossier vide"})
		};
		if (this.config.grid) Object.assign(initGrid, this.config.grid);
		const grid = <store-res-grid î={initGrid}/> as ResGrid;
		grid.resGridDatas.setNaturalOrder((a: JNodeShortProps, b: JNodeShortProps): number => urlTreeSrv.naturalSortPathFn(a.permaPath, b.permaPath));
		grid.setTilesAuto(12 * parseFloat(getComputedStyle(this).fontSize), this.reg); //12 em de large par tuile.
		grid.addEventListener('grid-select', (ev: Event) => {
			const node = grid.dataHolder.getDataByOffset(grid.getSelectedRow());
			if (node) new FocusLiveRes().executeIfAvailable(grid, ev);
		});

		urlTreeSrv.listChildren(this.reg.env.path, `&excludeAll&props=permaPath&childrenProps=${RES.NODEPROPS_short}&childrenFilter=${this.nodeFilter}&maxChildren=${this.config.max}`).then((parent) => {
			if (!parent || !parent.ch) {
				grid.resGridDatas.setDatas([]);
			} else {
				const parentPath = parent.permaPath;
				for (let ch of parent.ch as JNodeInfos[]) {
					ch.permaPath = URLTREE.appendLeafToPath(parentPath, ch);
				}
				// const copy = parent.ch.concat();
				// for (let i = 0; i < 8; i++) {
				// 	for (let c of copy) {
				// 		parent.ch.push(Object.assign({}, c));
				// 	}
				// }
				grid.resGridDatas.setDatas(parent.ch as JNodeInfos[]);
				if (parent.moreCh) this.showSeeAllBtn();
			}
		});
		const nodeInfosChange = (this.reg.env as IDepotResEnv).nodeInfosChange;
		if (nodeInfosChange) {
			nodeInfosChange.on("childChange", async (child: JStoreChangeProps) => {
				const props = await urlTreeSrv.nodeInfos(child.path, `&excludeAll&props=isHead*${RES.NODEPROPS_short}&matchFilter=${this.nodeFilter}`);
				if (!props || props.matchFilter === false) {
					grid.resGridDatas.removeByResPath(child.path, props?.isHead || false);
				} else if (props.isHead) {
					if (grid.resGridDatas.countRows() < this.config.max) {
						grid.resGridDatas.refreshOrInsertNode(props, true);
					} else {
						const rowKey = grid.resGridDatas.findRowKeyByResPath(props.permaPath);
						if (rowKey) grid.resGridDatas.refreshFields(rowKey, props);
						this.showSeeAllBtn();
					}
				}
			});
		}

		this.initBarActions(this.config, this.shadowRoot);
		this.shadowRoot.appendChild(grid);
	}

	showSeeAllBtn() {
		if (!this._seeAll && this.config.area instanceof ResChildrenArea) {
			const count = this.config.max;
			this._seeAll = new Button().initialize({
				reg: this.reg,
				uiContext: "dialog",
				label: `Plus de ${count} éléments, tout afficher en liste...`
			});
			this._seeAll.onclick = async () => {
				const tag = await ((this.config.area as ResTreeArea).asResTreeArea().loadBody(this));
				this.replaceWith(tag);
				VIEWS.onViewHidden(tag);
			}
			this.shadowRoot.appendChild(this._seeAll);
		}
	}

	_seeAll: Button;
}

REG.reg.registerSkin('store-res-children', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		min-height: 0;
	}

	store-res-grid {
		flex: 1;
		border: none;
	}

	c-bar-actions + store-res-grid {
		border-top: 1px solid var(--border-color);
	}
`);

customElements.define('store-res-children', ResChildrenView);